/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.2.0 (NJsonSchema v10.1.23.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { BaseClientApi, ClientApiConfig, ApiException } from  '@eta/components';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IIntermediariesClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    registerApplication(taxpayerID: number, body?: IntermediaryApplicationDto | undefined): Promise<number>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setApplicationStatus(taxpayerID: number, applicationID: number, body?: IntermediaryApplicationStatusDto | undefined): Promise<number>;
    /**
     * @return Success
     */
    intermediaries(): Promise<IntermediaryListResponseDto>;
    /**
     * @return Success
     */
    viewIntermediariesBasicDetails(taxpayerid: number): Promise<IntermediaryDetailsBaiscResponseDto>;
    /**
     * @return Success
     */
    viewIntermediariesFullDetails(taxpayerid: number): Promise<IntermediaryDetailsFullResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changeDocumentValidation(taxpayerid: number, id: number, body?: UpdateForcedValidationPeriodRequestDto | undefined): Promise<number>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createDocumentValidation(taxpayerid: number, body?: CreateForcedValidationPeriodRequestDto | undefined): Promise<number>;
    /**
     * @param representedTaxPayerName (optional) 
     * @param representedTaxPayerId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getInformationOfIntermediary(taxpayerid: number, representedTaxPayerName?: string | null | undefined, representedTaxPayerId?: number | undefined, dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined, pageSize?: number | undefined, pageNumber?: number | undefined): Promise<SearchIntermediaryResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    intermediaryBlockUnBlock(taxpayerid: number, body?: IntermediaryBlockUnBlockRequestDto | undefined): Promise<number>;
    /**
     * @param body (optional) 
     * @return Success
     */
    intermediaryRepresentations(representedtaxpayerID: number, body?: IntermediaryRepresentationsRequestDto | undefined): Promise<number>;
}

export class IntermediariesClient extends BaseClientApi implements IIntermediariesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientApiConfig, baseUrl?: string, instance?: AxiosInstance) {
        super(configuration);
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerApplication(taxpayerID: number, body?: IntermediaryApplicationDto | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/{taxpayerID}/application";
        if (taxpayerID === undefined || taxpayerID === null)
            throw new Error("The parameter 'taxpayerID' must be defined.");
        url_ = url_.replace("{taxpayerID}", encodeURIComponent("" + taxpayerID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterApplication(_response);
        });
    }

    protected processRegisterApplication(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setApplicationStatus(taxpayerID: number, applicationID: number, body?: IntermediaryApplicationStatusDto | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/{taxpayerID}/application/{applicationID}/status";
        if (taxpayerID === undefined || taxpayerID === null)
            throw new Error("The parameter 'taxpayerID' must be defined.");
        url_ = url_.replace("{taxpayerID}", encodeURIComponent("" + taxpayerID));
        if (applicationID === undefined || applicationID === null)
            throw new Error("The parameter 'applicationID' must be defined.");
        url_ = url_.replace("{applicationID}", encodeURIComponent("" + applicationID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetApplicationStatus(_response);
        });
    }

    protected processSetApplicationStatus(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    intermediaries(  cancelToken?: CancelToken | undefined): Promise<IntermediaryListResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntermediaries(_response);
        });
    }

    protected processIntermediaries(response: AxiosResponse): Promise<IntermediaryListResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntermediaryListResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntermediaryListResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    viewIntermediariesBasicDetails(taxpayerid: number , cancelToken?: CancelToken | undefined): Promise<IntermediaryDetailsBaiscResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/{taxpayerid}/basic";
        if (taxpayerid === undefined || taxpayerid === null)
            throw new Error("The parameter 'taxpayerid' must be defined.");
        url_ = url_.replace("{taxpayerid}", encodeURIComponent("" + taxpayerid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processViewIntermediariesBasicDetails(_response);
        });
    }

    protected processViewIntermediariesBasicDetails(response: AxiosResponse): Promise<IntermediaryDetailsBaiscResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntermediaryDetailsBaiscResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntermediaryDetailsBaiscResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    viewIntermediariesFullDetails(taxpayerid: number , cancelToken?: CancelToken | undefined): Promise<IntermediaryDetailsFullResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/{taxpayerid}/full";
        if (taxpayerid === undefined || taxpayerid === null)
            throw new Error("The parameter 'taxpayerid' must be defined.");
        url_ = url_.replace("{taxpayerid}", encodeURIComponent("" + taxpayerid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processViewIntermediariesFullDetails(_response);
        });
    }

    protected processViewIntermediariesFullDetails(response: AxiosResponse): Promise<IntermediaryDetailsFullResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntermediaryDetailsFullResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntermediaryDetailsFullResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeDocumentValidation(taxpayerid: number, id: number, body?: UpdateForcedValidationPeriodRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/{taxpayerid}/documentvalidation/{ID}";
        if (taxpayerid === undefined || taxpayerid === null)
            throw new Error("The parameter 'taxpayerid' must be defined.");
        url_ = url_.replace("{taxpayerid}", encodeURIComponent("" + taxpayerid));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeDocumentValidation(_response);
        });
    }

    protected processChangeDocumentValidation(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDocumentValidation(taxpayerid: number, body?: CreateForcedValidationPeriodRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/{taxpayerid}/documentvalidation";
        if (taxpayerid === undefined || taxpayerid === null)
            throw new Error("The parameter 'taxpayerid' must be defined.");
        url_ = url_.replace("{taxpayerid}", encodeURIComponent("" + taxpayerid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDocumentValidation(_response);
        });
    }

    protected processCreateDocumentValidation(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param representedTaxPayerName (optional) 
     * @param representedTaxPayerId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getInformationOfIntermediary(taxpayerid: number, representedTaxPayerName?: string | null | undefined, representedTaxPayerId?: number | undefined, dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined, pageSize?: number | undefined, pageNumber?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SearchIntermediaryResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/{taxpayerid}/representations?";
        if (taxpayerid === undefined || taxpayerid === null)
            throw new Error("The parameter 'taxpayerid' must be defined.");
        url_ = url_.replace("{taxpayerid}", encodeURIComponent("" + taxpayerid));
        if (representedTaxPayerName !== undefined && representedTaxPayerName !== null)
            url_ += "RepresentedTaxPayerName=" + encodeURIComponent("" + representedTaxPayerName) + "&";
        if (representedTaxPayerId === null)
            throw new Error("The parameter 'representedTaxPayerId' cannot be null.");
        else if (representedTaxPayerId !== undefined)
            url_ += "RepresentedTaxPayerId=" + encodeURIComponent("" + representedTaxPayerId) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInformationOfIntermediary(_response);
        });
    }

    protected processGetInformationOfIntermediary(response: AxiosResponse): Promise<SearchIntermediaryResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchIntermediaryResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchIntermediaryResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    intermediaryBlockUnBlock(taxpayerid: number, body?: IntermediaryBlockUnBlockRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/{taxpayerid}/status";
        if (taxpayerid === undefined || taxpayerid === null)
            throw new Error("The parameter 'taxpayerid' must be defined.");
        url_ = url_.replace("{taxpayerid}", encodeURIComponent("" + taxpayerid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntermediaryBlockUnBlock(_response);
        });
    }

    protected processIntermediaryBlockUnBlock(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    intermediaryRepresentations(representedtaxpayerID: number, body?: IntermediaryRepresentationsRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/representations/{representedtaxpayerID}";
        if (representedtaxpayerID === undefined || representedtaxpayerID === null)
            throw new Error("The parameter 'representedtaxpayerID' must be defined.");
        url_ = url_.replace("{representedtaxpayerID}", encodeURIComponent("" + representedtaxpayerID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntermediaryRepresentations(_response);
        });
    }

    protected processIntermediaryRepresentations(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }
}

export enum ApplicationTypes {
    None = "None",
    Initial = "Initial",
    Renewal = "Renewal",
}

export class AddressDto implements IAddressDto {
    streetName?: string | undefined;
    buildingNo?: string | undefined;
    flatNo?: string | undefined;
    cityID?: number | undefined;
    governorateID?: number | undefined;
    countryID?: number;
    countryCode?: string | undefined;
    floorNo?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    streetName2?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetName = _data["streetName"];
            this.buildingNo = _data["buildingNo"];
            this.flatNo = _data["flatNo"];
            this.cityID = _data["cityID"];
            this.governorateID = _data["governorateID"];
            this.countryID = _data["countryID"];
            this.countryCode = _data["countryCode"];
            this.floorNo = _data["floorNo"];
            this.additionalInformation = _data["additionalInformation"];
            this.postalCode = _data["postalCode"];
            this.streetName2 = _data["streetName2"];
            this.foreignGovernorateName = _data["foreignGovernorateName"];
            this.foreignCityName = _data["foreignCityName"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetName"] = this.streetName;
        data["buildingNo"] = this.buildingNo;
        data["flatNo"] = this.flatNo;
        data["cityID"] = this.cityID;
        data["governorateID"] = this.governorateID;
        data["countryID"] = this.countryID;
        data["countryCode"] = this.countryCode;
        data["floorNo"] = this.floorNo;
        data["additionalInformation"] = this.additionalInformation;
        data["postalCode"] = this.postalCode;
        data["streetName2"] = this.streetName2;
        data["foreignGovernorateName"] = this.foreignGovernorateName;
        data["foreignCityName"] = this.foreignCityName;
        return data; 
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    streetName?: string | undefined;
    buildingNo?: string | undefined;
    flatNo?: string | undefined;
    cityID?: number | undefined;
    governorateID?: number | undefined;
    countryID?: number;
    countryCode?: string | undefined;
    floorNo?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    streetName2?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;
}

export enum FileTypes {
    None = "None",
    PNG = "PNG",
    JPG = "JPG",
    JPEG = "JPEG",
    PDF = "PDF",
}

export class ApplicationAttachmentDto implements IApplicationAttachmentDto {
    fileName?: string | undefined;
    fileType?: FileTypes;
    fileContent?: string | undefined;

    constructor(data?: IApplicationAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileContent = _data["fileContent"];
        }
    }

    static fromJS(data: any): ApplicationAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileContent"] = this.fileContent;
        return data; 
    }

    clone(): ApplicationAttachmentDto {
        const json = this.toJSON();
        let result = new ApplicationAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationAttachmentDto {
    fileName?: string | undefined;
    fileType?: FileTypes;
    fileContent?: string | undefined;
}

export class IntermediaryApplicationDto implements IIntermediaryApplicationDto {
    intermediaryId?: number | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    descriptionPrimaryLang?: string | undefined;
    descriptionSecondaryLang?: string | undefined;
    mobileNo?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    type?: ApplicationTypes;
    note?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    address?: AddressDto;
    applicationAttachments?: ApplicationAttachmentDto[] | undefined;

    constructor(data?: IIntermediaryApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intermediaryId = _data["intermediaryId"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.descriptionPrimaryLang = _data["descriptionPrimaryLang"];
            this.descriptionSecondaryLang = _data["descriptionSecondaryLang"];
            this.mobileNo = _data["mobileNo"];
            this.email = _data["email"];
            this.url = _data["url"];
            this.type = _data["type"];
            this.note = _data["note"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["applicationAttachments"])) {
                this.applicationAttachments = [] as any;
                for (let item of _data["applicationAttachments"])
                    this.applicationAttachments!.push(ApplicationAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntermediaryApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intermediaryId"] = this.intermediaryId;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["descriptionPrimaryLang"] = this.descriptionPrimaryLang;
        data["descriptionSecondaryLang"] = this.descriptionSecondaryLang;
        data["mobileNo"] = this.mobileNo;
        data["email"] = this.email;
        data["url"] = this.url;
        data["type"] = this.type;
        data["note"] = this.note;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.applicationAttachments)) {
            data["applicationAttachments"] = [];
            for (let item of this.applicationAttachments)
                data["applicationAttachments"].push(item.toJSON());
        }
        return data; 
    }

    clone(): IntermediaryApplicationDto {
        const json = this.toJSON();
        let result = new IntermediaryApplicationDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryApplicationDto {
    intermediaryId?: number | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    descriptionPrimaryLang?: string | undefined;
    descriptionSecondaryLang?: string | undefined;
    mobileNo?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    type?: ApplicationTypes;
    note?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    address?: AddressDto;
    applicationAttachments?: ApplicationAttachmentDto[] | undefined;
}

export enum ApplicationStatuses {
    None = "None",
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
}

export class IntermediaryApplicationStatusDto implements IIntermediaryApplicationStatusDto {
    status?: ApplicationStatuses;
    note?: string | undefined;
    activeFrom?: Date | undefined;
    activeTo?: Date | undefined;

    constructor(data?: IIntermediaryApplicationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.note = _data["note"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IntermediaryApplicationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryApplicationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["note"] = this.note;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data; 
    }

    clone(): IntermediaryApplicationStatusDto {
        const json = this.toJSON();
        let result = new IntermediaryApplicationStatusDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryApplicationStatusDto {
    status?: ApplicationStatuses;
    note?: string | undefined;
    activeFrom?: Date | undefined;
    activeTo?: Date | undefined;
}

export class RegisteredIntermediariesDto implements IRegisteredIntermediariesDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    validEmail?: string | undefined;

    constructor(data?: IRegisteredIntermediariesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.validEmail = _data["validEmail"];
        }
    }

    static fromJS(data: any): RegisteredIntermediariesDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisteredIntermediariesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["validEmail"] = this.validEmail;
        return data; 
    }

    clone(): RegisteredIntermediariesDto {
        const json = this.toJSON();
        let result = new RegisteredIntermediariesDto();
        result.init(json);
        return result;
    }
}

export interface IRegisteredIntermediariesDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    validEmail?: string | undefined;
}

export class ActivityPeriodDto implements IActivityPeriodDto {
    id?: number;
    activeFrom?: Date;
    activeTo?: Date | undefined;

    constructor(data?: IActivityPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data; 
    }

    clone(): ActivityPeriodDto {
        const json = this.toJSON();
        let result = new ActivityPeriodDto();
        result.init(json);
        return result;
    }
}

export interface IActivityPeriodDto {
    id?: number;
    activeFrom?: Date;
    activeTo?: Date | undefined;
}

export class CandidateIntermediariesDto implements ICandidateIntermediariesDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    email?: string | undefined;
    activityPeriod?: ActivityPeriodDto[] | undefined;

    constructor(data?: ICandidateIntermediariesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.email = _data["email"];
            if (Array.isArray(_data["activityPeriod"])) {
                this.activityPeriod = [] as any;
                for (let item of _data["activityPeriod"])
                    this.activityPeriod!.push(ActivityPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidateIntermediariesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateIntermediariesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["email"] = this.email;
        if (Array.isArray(this.activityPeriod)) {
            data["activityPeriod"] = [];
            for (let item of this.activityPeriod)
                data["activityPeriod"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CandidateIntermediariesDto {
        const json = this.toJSON();
        let result = new CandidateIntermediariesDto();
        result.init(json);
        return result;
    }
}

export interface ICandidateIntermediariesDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    email?: string | undefined;
    activityPeriod?: ActivityPeriodDto[] | undefined;
}

export class IntermediaryListResponseDto implements IIntermediaryListResponseDto {
    registeredIntermediaries?: RegisteredIntermediariesDto[] | undefined;
    candidateIntermediaries?: CandidateIntermediariesDto[] | undefined;

    constructor(data?: IIntermediaryListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["registeredIntermediaries"])) {
                this.registeredIntermediaries = [] as any;
                for (let item of _data["registeredIntermediaries"])
                    this.registeredIntermediaries!.push(RegisteredIntermediariesDto.fromJS(item));
            }
            if (Array.isArray(_data["candidateIntermediaries"])) {
                this.candidateIntermediaries = [] as any;
                for (let item of _data["candidateIntermediaries"])
                    this.candidateIntermediaries!.push(CandidateIntermediariesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntermediaryListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.registeredIntermediaries)) {
            data["registeredIntermediaries"] = [];
            for (let item of this.registeredIntermediaries)
                data["registeredIntermediaries"].push(item.toJSON());
        }
        if (Array.isArray(this.candidateIntermediaries)) {
            data["candidateIntermediaries"] = [];
            for (let item of this.candidateIntermediaries)
                data["candidateIntermediaries"].push(item.toJSON());
        }
        return data; 
    }

    clone(): IntermediaryListResponseDto {
        const json = this.toJSON();
        let result = new IntermediaryListResponseDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryListResponseDto {
    registeredIntermediaries?: RegisteredIntermediariesDto[] | undefined;
    candidateIntermediaries?: CandidateIntermediariesDto[] | undefined;
}

export class IntermediaryDetailsBaiscResponseDto implements IIntermediaryDetailsBaiscResponseDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    validEmail?: string | undefined;
    activityPeriod?: ActivityPeriodDto[] | undefined;

    constructor(data?: IIntermediaryDetailsBaiscResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.validEmail = _data["validEmail"];
            if (Array.isArray(_data["activityPeriod"])) {
                this.activityPeriod = [] as any;
                for (let item of _data["activityPeriod"])
                    this.activityPeriod!.push(ActivityPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntermediaryDetailsBaiscResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryDetailsBaiscResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["validEmail"] = this.validEmail;
        if (Array.isArray(this.activityPeriod)) {
            data["activityPeriod"] = [];
            for (let item of this.activityPeriod)
                data["activityPeriod"].push(item.toJSON());
        }
        return data; 
    }

    clone(): IntermediaryDetailsBaiscResponseDto {
        const json = this.toJSON();
        let result = new IntermediaryDetailsBaiscResponseDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryDetailsBaiscResponseDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    validEmail?: string | undefined;
    activityPeriod?: ActivityPeriodDto[] | undefined;
}

export class IntermediaryDetailsFullResponseDto implements IIntermediaryDetailsFullResponseDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    validEmail?: string | undefined;

    constructor(data?: IIntermediaryDetailsFullResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.validEmail = _data["validEmail"];
        }
    }

    static fromJS(data: any): IntermediaryDetailsFullResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryDetailsFullResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["validEmail"] = this.validEmail;
        return data; 
    }

    clone(): IntermediaryDetailsFullResponseDto {
        const json = this.toJSON();
        let result = new IntermediaryDetailsFullResponseDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryDetailsFullResponseDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    validEmail?: string | undefined;
}

export class UpdateForcedValidationPeriodRequestDto implements IUpdateForcedValidationPeriodRequestDto {
    activeFrom?: Date;
    activeTo?: Date | undefined;

    constructor(data?: IUpdateForcedValidationPeriodRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateForcedValidationPeriodRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateForcedValidationPeriodRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data; 
    }

    clone(): UpdateForcedValidationPeriodRequestDto {
        const json = this.toJSON();
        let result = new UpdateForcedValidationPeriodRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateForcedValidationPeriodRequestDto {
    activeFrom?: Date;
    activeTo?: Date | undefined;
}

export class CreateForcedValidationPeriodRequestDto implements ICreateForcedValidationPeriodRequestDto {
    activeFrom?: Date;
    activeTo?: Date | undefined;

    constructor(data?: ICreateForcedValidationPeriodRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateForcedValidationPeriodRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateForcedValidationPeriodRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data; 
    }

    clone(): CreateForcedValidationPeriodRequestDto {
        const json = this.toJSON();
        let result = new CreateForcedValidationPeriodRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICreateForcedValidationPeriodRequestDto {
    activeFrom?: Date;
    activeTo?: Date | undefined;
}

export class IntermediaryTaxpayerRepresentationDto implements IIntermediaryTaxpayerRepresentationDto {
    id?: number;
    taxpayerId?: number;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    isActive?: boolean;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;

    constructor(data?: IIntermediaryTaxpayerRepresentationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taxpayerId = _data["taxpayerId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
        }
    }

    static fromJS(data: any): IntermediaryTaxpayerRepresentationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryTaxpayerRepresentationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taxpayerId"] = this.taxpayerId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        return data; 
    }

    clone(): IntermediaryTaxpayerRepresentationDto {
        const json = this.toJSON();
        let result = new IntermediaryTaxpayerRepresentationDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryTaxpayerRepresentationDto {
    id?: number;
    taxpayerId?: number;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    isActive?: boolean;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
}

export class MetaData implements IMetaData {
    totalPages?: number;
    totalCount?: number;

    constructor(data?: IMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MetaData {
        data = typeof data === 'object' ? data : {};
        let result = new MetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): MetaData {
        const json = this.toJSON();
        let result = new MetaData();
        result.init(json);
        return result;
    }
}

export interface IMetaData {
    totalPages?: number;
    totalCount?: number;
}

export class SearchIntermediaryResponseDto implements ISearchIntermediaryResponseDto {
    result?: IntermediaryTaxpayerRepresentationDto[] | undefined;
    metadata?: MetaData;

    constructor(data?: ISearchIntermediaryResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(IntermediaryTaxpayerRepresentationDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? MetaData.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchIntermediaryResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchIntermediaryResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SearchIntermediaryResponseDto {
        const json = this.toJSON();
        let result = new SearchIntermediaryResponseDto();
        result.init(json);
        return result;
    }
}

export interface ISearchIntermediaryResponseDto {
    result?: IntermediaryTaxpayerRepresentationDto[] | undefined;
    metadata?: MetaData;
}

export enum IntermediaryStatusTypes {
    None = "None",
    Blocked = "Blocked",
    Unblocked = "Unblocked",
}

export class IntermediaryBlockUnBlockRequestDto implements IIntermediaryBlockUnBlockRequestDto {
    status?: IntermediaryStatusTypes;
    statusNote?: string | undefined;

    constructor(data?: IIntermediaryBlockUnBlockRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusNote = _data["statusNote"];
        }
    }

    static fromJS(data: any): IntermediaryBlockUnBlockRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryBlockUnBlockRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusNote"] = this.statusNote;
        return data; 
    }

    clone(): IntermediaryBlockUnBlockRequestDto {
        const json = this.toJSON();
        let result = new IntermediaryBlockUnBlockRequestDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryBlockUnBlockRequestDto {
    status?: IntermediaryStatusTypes;
    statusNote?: string | undefined;
}

export class IntermediaryRepresentationDto implements IIntermediaryRepresentationDto {
    taxpayerId?: number;
    activeFrom?: Date;
    activeTo?: Date | undefined;

    constructor(data?: IIntermediaryRepresentationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxpayerId = _data["taxpayerId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IntermediaryRepresentationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryRepresentationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxpayerId"] = this.taxpayerId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data; 
    }

    clone(): IntermediaryRepresentationDto {
        const json = this.toJSON();
        let result = new IntermediaryRepresentationDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryRepresentationDto {
    taxpayerId?: number;
    activeFrom?: Date;
    activeTo?: Date | undefined;
}

export class IntermediaryRepresentationsRequestDto implements IIntermediaryRepresentationsRequestDto {
    activeIntermediaryTaxpayerRepresentation?: IntermediaryRepresentationDto[] | undefined;
    inActiveIntermediaryTaxpayerRepresentation?: IntermediaryRepresentationDto[] | undefined;

    constructor(data?: IIntermediaryRepresentationsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activeIntermediaryTaxpayerRepresentation"])) {
                this.activeIntermediaryTaxpayerRepresentation = [] as any;
                for (let item of _data["activeIntermediaryTaxpayerRepresentation"])
                    this.activeIntermediaryTaxpayerRepresentation!.push(IntermediaryRepresentationDto.fromJS(item));
            }
            if (Array.isArray(_data["inActiveIntermediaryTaxpayerRepresentation"])) {
                this.inActiveIntermediaryTaxpayerRepresentation = [] as any;
                for (let item of _data["inActiveIntermediaryTaxpayerRepresentation"])
                    this.inActiveIntermediaryTaxpayerRepresentation!.push(IntermediaryRepresentationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntermediaryRepresentationsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryRepresentationsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeIntermediaryTaxpayerRepresentation)) {
            data["activeIntermediaryTaxpayerRepresentation"] = [];
            for (let item of this.activeIntermediaryTaxpayerRepresentation)
                data["activeIntermediaryTaxpayerRepresentation"].push(item.toJSON());
        }
        if (Array.isArray(this.inActiveIntermediaryTaxpayerRepresentation)) {
            data["inActiveIntermediaryTaxpayerRepresentation"] = [];
            for (let item of this.inActiveIntermediaryTaxpayerRepresentation)
                data["inActiveIntermediaryTaxpayerRepresentation"].push(item.toJSON());
        }
        return data; 
    }

    clone(): IntermediaryRepresentationsRequestDto {
        const json = this.toJSON();
        let result = new IntermediaryRepresentationsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryRepresentationsRequestDto {
    activeIntermediaryTaxpayerRepresentation?: IntermediaryRepresentationDto[] | undefined;
    inActiveIntermediaryTaxpayerRepresentation?: IntermediaryRepresentationDto[] | undefined;
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}